<template>
    <div class="feedback-stars__wrapper">
        <a @click.prevent href="#" class="feedback-stars__amount">
            {{ counts.ratingsCountTotal }} {{ $translate('OD3dprimaV2::Template.ratings') }}&nbsp;&nbsp;
        </a>
        <div v-if="showEmptyRatings || counts.averageValue > 0" class="feedback-stars-average" :class="size">
            <div class="feedback-stars-background clearfix">
                <div class="feedback-star" v-for="index in 5">
                    <i class="fa fa-star"></i>
                </div>
            </div>
            <div class="feedback-stars-overlay-wrap" :style="{width: fill}">
                <div class="feedback-stars-overlay clearfix">
                    <div class="feedback-star" v-for="index in 5">
                        <i class="fa fa-star"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: [
        'showEmptyRatings',
        'sizeOfStars',
        'showRatingsAmount'
    ],
    inject: {
        itemId: {
            default: null
        }
    },
    data: function () {
        return {
            counts: {
                'averageValue': 0,
                'ratingsCountTotal': 0
            }
        };
    },
    mounted: function () {
        let _self = this;
        this.$root.$on('averageRecalc', function () {
            _self.getAverage();
        });
        if (!App.isShopBuilder) {
            this.getAverage();
        }
    },
    methods: {
        getAverage () {
            let _self = this;
            return $.ajax({
                type: 'GET',
                url: '/rest/feedbacks/feedback/helper/average/' + _self.itemId,
                success: function (data) {
                    _self.counts = data;
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error(errorThrown);
                }
            });
        }
    },
    computed: {
        fill: function () {
            let fillValue = (this.counts.averageValue * 100) / 5;
            fillValue += '%';
            return fillValue;
        },
        size: function () {
            return this.sizeOfStars.indexOf('-stars') !== -1 ? this.sizeOfStars : this.sizeOfStars + '-stars';
        }
    }
};
</script>
